export default {
    INDEX: '/',
    ENTRY_FORM: '/entry-form',
    LOGIN: '/login',
    LOGOUT: '/logout',
    ADMIN_PANEL: '/admin',
    SEND_MAILS: '/api/mailer/send',
    STUDENT_LIST: '/admin/list',
    EVENT_MANAGER: '/admin/event',
    EXCEL_ADD: '/admin/excel',
    ROOMS: '/rooms',
    ROOM_TAKE: '/rooms/take'
}


// WEBPACK FOOTER //
// ./src/base/urls.js